//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FilterOption',
  props: {
    options: {
      type: Array,
      default: () => ([]),
    },
    offset: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'multi',
    },
    value: Object,
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: this.show,
    }
  },
  computed: {
    selectedOption() {
      return this.value
    },
  },
  watch: {
    options() {
      this.$nextTick(() => {
        console.log(this.options)
        const optionHeight = this.$el.offsetHeight
        const mask = document.getElementById('option-mask')
        mask.style.top = `${optionHeight + this.offset}px`
      })
    },
  },
  methods: {
    switchOption(option) {
      this.selectedOption = option
      this.isVisible = false
      this.$emit('change', option, this.isVisible)
    },
    onClose() {
      this.$emit('onFilterClose')
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/FilterOption.vue